import { createSlice } from "@reduxjs/toolkit";
import {
  listChecklistStages,
  createChecklistStage,
  updateChecklistStage,
  deleteChecklistStage,
  listChecklistTemplates,
  createChecklistTemplate,
  updateChecklistTemplate,
  deleteChecklistTemplate
} from "../Action/Checklist";

const ChecklistSlice = createSlice({
  name: "Checklist",
  initialState: {
    stages: [],
    templates: []
  },
  reducers: {},
  extraReducers: (builder) => {
    // Stages
    builder.addCase(listChecklistStages.fulfilled, (state, action) => {
      state.stages = action.payload || [];
    });
    builder.addCase(createChecklistStage.fulfilled, (state, action) => {
      if (action.payload) state.stages.push(action.payload);
    });
    builder.addCase(updateChecklistStage.fulfilled, (state, action) => {
      const idx = state.stages.findIndex((s) => s._id === action.payload?._id);
      if (idx >= 0) state.stages[idx] = action.payload;
    });
    builder.addCase(deleteChecklistStage.fulfilled, (state, action) => {
      const id = action.payload?.id;
      if (!id) return;
      state.stages = state.stages.filter((s) => s._id !== id);
    });

    // Templates
    builder.addCase(listChecklistTemplates.fulfilled, (state, action) => {
      state.templates = action.payload || [];
    });
    builder.addCase(createChecklistTemplate.fulfilled, (state, action) => {
      if (action.payload) state.templates.push(action.payload);
    });
    builder.addCase(updateChecklistTemplate.fulfilled, (state, action) => {
      const idx = state.templates.findIndex((t) => t._id === action.payload?._id);
      if (idx >= 0) state.templates[idx] = action.payload;
    });
    builder.addCase(deleteChecklistTemplate.fulfilled, (state, action) => {
      const id = action.payload?.id;
      if (!id) return;
      state.templates = state.templates.filter((t) => t._id !== id);
    });
  }
});

export default ChecklistSlice.reducer;

